import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { ReservationManagement } from "@/components/settings/admin/reservations/ReservationManagement";
import { useProfile } from "@/hooks/useProfile";
import { useRecepcionistaRedirect } from "@/hooks/useRecepcionistaRedirect";

const GestionReservas = () => {
  const { gymId } = useParams();
  const navigate = useNavigate();
  const { profile } = useProfile();
  const { isRecepcionista } = useRecepcionistaRedirect();

  const { data: gym, isLoading } = useQuery({
    queryKey: ["gym", gymId],
    queryFn: async () => {
      if (!gymId) return null;
      const { data, error } = await supabase
        .from("gyms")
        .select("*")
        .eq("id", gymId)
        .single();
      if (error) throw error;
      return data;
    },
    enabled: !!gymId,
  });

  if (!gymId) return null;

  const handleBack = () => {
    if (isRecepcionista) {
      navigate("/recepcionista");
    } else {
      navigate("/configuracion?tab=admin&subtab=gym");
    }
  };

  return (
    <div className="min-h-screen pt-16 bg-background text-primary">
      <header className="border-b border-border">
        <div className="container py-4">
          <Button
            variant="ghost"
            onClick={handleBack}
            className="mb-4 text-primary hover:bg-primary/10"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver
          </Button>
          <h1 className="text-2xl font-heading font-bold text-primary">
            Gestión de Reservas {gym?.name ? `- ${gym.name}` : ""}
          </h1>
        </div>
      </header>
      <main className="container py-6">
        {!isLoading && gym && <ReservationManagement gym={gym} />}
      </main>
    </div>
  );
};

export default GestionReservas;
